import { gql } from "apollo-angular";
import { CptsFilters } from "../../models/cpt.model";
import { CPTS_FIELD } from "./cpt.enum";
import { OrderingType } from "../../../features/administration/legal-entities/legal-entities.component";
import { buildSearchSchema, buildStringSchema } from "../graph-ql.operations";

export const CPT_TABLE_FRAGMENT = gql`
  fragment CptTableData on CptCatalogueNode {
      auditDomain
      auditSubdomain
      cluster
      code
      id
      internalAuditDomain
      name
      valueChain
      processStatus
      subNodes {
        auditDomain
        auditSubdomain
        cluster
        code
        id
        internalAuditDomain
        name
        processStatus
        valueChain
        subNodes {
          auditDomain
          auditSubdomain
          cluster
          code
          id
          internalAuditDomain
          name
          processStatus
          valueChain
         
      }
    }
  }
`;

export const CPT_TABLE_QUERY = (
  filters: CptsFilters,
  search: string,
  order?: OrderingType
) => gql`
  query GetCpts($page: PagingInput, $direction: OrderTypeInput, $sortField: CptCatalogueV2Columns) {
    cptCatalogueByQueryComplex(
      query: { 
            operator: AND, 
            query: [
              { 
                query: [
                  ${buildStringSchema(filters, CPTS_FIELD)}
                ] 
              }, 
              ${search && search !== '' ? `
                { 
                  operator: OR, 
                  query: [
                    ${buildSearchSchema(search, [
  "AUDIT_AREA",
  "AUDIT_SUB_AREA",
  "LEVEL_ONE_CLUSTER",
  "LEVEL_TWO_CLUSTER",
  "LEVEL_THREE_CLUSTER",
  "LEVEL_ONE_INTERNAL_AUDIT_DOMAIN",
  "LEVEL_TWO_INTERNAL_AUDIT_DOMAIN",
  "LEVEL_THREE_INTERNAL_AUDIT_DOMAIN",
  "LEVEL_ONE_PROCESS_CODE",
  "LEVEL_TWO_PROCESS_CODE",
  "LEVEL_THREE_PROCESS_CODE",
  "LEVEL_ONE_PROCESS_NAME",
  "LEVEL_TWO_PROCESS_NAME",
  "LEVEL_THREE_PROCESS_NAME",
  "LEVEL_ONE_PROCESS_STATUS",
  "LEVEL_TWO_PROCESS_STATUS",
  "LEVEL_THREE_PROCESS_STATUS",
  "LEVEL_ONE_VALUE_CHAIN",
  "LEVEL_TWO_VALUE_CHAIN",
  "LEVEL_THREE_VALUE_CHAIN"
]) ?? ""}
                  ] 
                }
                ` : ''
  }
              
            ] 
          }
      page: $page
      sort:{ sortOrder: $direction , sortField: $sortField }
    ) {
      ...PaginatedCPTFragment
      data {
        ...CptTableData
      }
    }
  }
  ${PAGINATED_CPT_FRAGMENT}
  ${CPT_TABLE_FRAGMENT}
`;

export const PAGINATED_CPT_FRAGMENT = gql`
  fragment PaginatedCPTFragment on CptCatalogueQueryResponse {
    pageSize
    pageIndex
    totalPages
    totalElements
  }
`;

export const CPT_TABLE_NAMES = (...names: string[]) => gql`
  query {
    cptCatalogue(
      page: { pageSize: 10000000, pageNo: 0 }
    ) {
      data {
        ${names.map((name) => name.toString() + "\n")}
      }
    }
  }
`;

// function buildStringSchema(filters: CptsFilters) {
//   let result = "";
//   // // console.log("Setting filters: ", filters);

//   Object.entries(filters).map(
//     (filter) => (result += `${[filter[0]]}:${JSON.stringify(filter[1])},`)
//   );
//   // // console.log("Returning filters: ", filters);
//   return result;
// }

export const GET_CPT_TABLE = gql`
  query {
    cpt {
      ...CptTableData
    }
  }
  ${CPT_TABLE_FRAGMENT}
`;

export const EXPORT_CPTS = (filters: CptsFilters, search: string) => gql`
  mutation exportCpts ($direction: OrderTypeInput, $sortField: CptCatalogueV2Columns){
    downloadCptCatalogueNodesByQuery(
      query:[
          ${buildStringSchema(filters, CPTS_FIELD)}
          ${buildSearchSchema(search, ["LEVEL_ONE_PROCESS_NAME"]) ?? ""}
      ]
      sort:{ sortOrder: $direction , sortField: $sortField }
    ) {
      data {
        content
        filename
      }
    }
  }
`;
export const SYNCRONIZE_CPTS = () => gql`
  mutation syncronizeCpts{
    batchExecutionCptCatalogue {
      data
      message
      statusCode
    }
  }
`;
